import axios from "axios";
// Login User
const login = async (userData)=> {
    const res = await axios.post(process.env.REACT_APP_FIND_API_URL + "/auth/login-seller-user", userData, { withCredentials: true, credentials: 'include'});
    localStorage.setItem('refreshToken',res.data.refreshToken)
    return res.data;
}
const getUser = async (refreshToken)=> {
    const res = await axios.get(process.env.REACT_APP_FIND_API_URL + '/auth/get-user-by-accesstoken', { withCredentials: true, credentials: 'include', headers:{
        "authorization": refreshToken
    }});
    return res.data;
}
const authService = {
    login,
    getUser
}
export default authService;